<template>
  <div>
    <v-navigation-drawer app overflow v-model="drawer" color="white">
      <div style="margin-top: 30px; margin-bottom: 20px">
        <v-row style="cursor: pointer" justify="center" align="center">
          <img
            width="55"
            src="../assets/nuvending_logo.jpeg"
            alt="nuvending_logo"
          />
          <div style="margin-left: 10px; font-size: 23px">
            <h4>NU VENDING</h4>
          </div>
        </v-row>
      </div>
      <v-list shaped>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            @click="navigate(item.nav)"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                class="text-wrap"
                v-text="item.text"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app flat short color="white">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <template v-if="$store.getters.getCurrentPage == 'RefillServiceScreen'">
        <div style="width: 300px">
          <v-autocomplete
            outlined
            dense
            rounded
            hide-details
            :items="machine_list"
            :item-text="(item) => item.machine_id + ' - ' + item.machine_name"
            :item-value="(item) => item.machine_id + ' - ' + item.machine_name"
            v-model="selected_machine"
            @input="machine_selected"
          ></v-autocomplete>
        </div>
      </template>
      <v-spacer></v-spacer>
      <div style="margin-right: 10px">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-on="on" v-bind="attrs" @click="logout">
              <v-icon color="black">mdi-logout-variant</v-icon>
            </v-btn>
          </template>
          <span>Logout</span>
        </v-tooltip>
      </div>
      <div style="margin-right: 20px">
        <p style="margin-bottom: 0px">{{ $store.getters.getUserName }}</p>
      </div>
      <img width="35" src="../assets/profile_image.svg" alt="profile_image" />
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      drawer: true,
      selectedItem: 1,
      currentPage: "",
      items: [
        {
          text: "Dashboard",
          icon: "mdi-view-dashboard-variant",
          nav: "HomeScreen",
        },
        {
          text: "Users",
          icon: "mdi-account-group",
          nav: "UserScreen",
        },
        {
          text: "Operator Roles",
          icon: "mdi-account-child",
          nav: "RoleScreen",
        },
        {
          text: "App Permissions",
          icon: "mdi-account-cog",
          nav: "AppPermissionScreen",
        },
        { text: "Machines", icon: "mdi-tools", nav: "MachineScreen" },
        {
          text: "Machine Templates",
          icon: "mdi-dock-window",
          nav: "MachineTemplateScreen",
        },
        {
          text: "Refill Service",
          icon: "mdi-truck",
          nav: "RefillServiceScreen",
        },
        {
          text: "Claim Log",
          icon: "mdi-account-cash",
          nav: "CommissionLogScreen",
        },
        { text: "Products", icon: "mdi-math-compass", nav: "ProductScreen" },
        {
          text: "Vending Machines",
          icon: "mdi-robot-happy",
          nav: "VendingMachineScreen",
        },
        { text: "Spare Parts", icon: "mdi-cogs", nav: "SparePartScreen" },
        { text: "Locations", icon: "mdi-map-marker", nav: "LocationScreen" },
        { text: "Shops", icon: "mdi-store", nav: "ShopScreen" },
        {
          text: "Job Schedule",
          icon: "mdi-clipboard-multiple",
          nav: "JobScheduleScreen",
        },
        {
          text: "Announcements",
          icon: "mdi-bullhorn",
          nav: "AnnouncementScreen",
        },
      ],
      machine_list: [],
      selected_machine: "",
    };
  },
  methods: {
    machine_selected(value) {
      this.$store.dispatch("updateSelectedMachine", { selectedMachine: value });
      // console.log(this.$store.getters.getSelectedMachine);
      this.$router.go();
    },
    load_header() {
      var user_roles = this.$store.getters.getUserRoleList;
      var user_company = this.$store.getters.getUserCompanyDocId;
      if (user_company != "") {
        this.items = [
          { text: "Dashboard", icon: "mdi-view-dashboard", nav: "HomeScreen" },
        ];
        // Users (manager,viewer,admin)
        if (
          user_roles.includes("Wbl2TAMLlfwkX8QDwztB") ||
          user_roles.includes("Q5C0tm2ysYOI4lGPRODc") ||
          user_roles.includes("UsVr0wHOjW29JiLaIv0E")
        ) {
          this.items.push({
            text: "Users",
            icon: "mdi-account-group",
            nav: "UserScreen",
          });
        }
        // Machine
        if (
          user_roles.includes("3BAFVFaySyJIFMdot8rB") ||
          user_roles.includes("xg3QiWhT2SA6KdkGFAeP") ||
          user_roles.includes("UsVr0wHOjW29JiLaIv0E")
        ) {
          this.items.push({
            text: "Machines",
            icon: "mdi-tools",
            nav: "MachineScreen",
          });
        }

        //Machine Templates
        if (
          user_roles.includes("N4sA8oghdJlrrsG1A8Ry") ||
          user_roles.includes("oS6LYQsmZ98ZsGx5ZItZ") ||
          user_roles.includes("UsVr0wHOjW29JiLaIv0E")
        ) {
          this.items.push({
            text: "Machine Templates",
            icon: "mdi-dock-window",
            nav: "MachineTemplateScreen",
          });
        }

        //Refill Feature
        if (
          user_roles.includes("Mi2PLUvyhPb7fgXOynEp") ||
          user_roles.includes("R23iynu9Wz4du6IX50rK") ||
          user_roles.includes("UsVr0wHOjW29JiLaIv0E")
        ) {
          this.items.push({
            text: "Refill Service",
            icon: "mdi-truck",
            nav: "RefillServiceScreen",
          });
        }

        //commission log
        if (
          user_roles.includes("qHeDHIMwA3UD02cPqw0G") ||
          user_roles.includes("UsVr0wHOjW29JiLaIv0E")
        ) {
          this.items.push({
            text: "Claim Log",
            icon: "mdi-account-cash",
            nav: "CommissionLogScreen",
          });
        }
      }
    },
    navigate(route) {
      if (route == "UserScreen") {
        this.$router
          .push({ name: route, params: { tab: "customers" } })
          .catch((error) => {});
      } else {
        this.$router.push({ name: route }).catch((error) => {});
      }
    },
    logout() {
      var payload = {
        userName: "",
        userID: "",
        userType: [],
        userCompanyDocId: "",
        userRoleList: [],
      };
      this.$store.dispatch("updateUserName", payload);
      this.$store.dispatch("updateUserID", payload);
      this.$store.dispatch("updateUserType", payload);
      this.$store.dispatch("updateUserCompanyDocId", payload);
      this.$store.dispatch("updateUserRoleList", payload);
      this.$router.push({ name: "SignInScreen" }).catch((error) => {});
    },
  },
  created() {
    this.load_header();
    this.$store.watch((state, getters) => {
      this.machine_list = getters.getMachineList;
      this.selected_machine = getters.getSelectedMachine;
      this.currentPage = getters.getCurrentPage;
      this.selectedItem = this.items.findIndex(
        (x) => x.nav == this.currentPage
      );
    });
  },
  mounted() {},
};
</script>

<style>
</style>